export default __webpack_public_path__ + "static/media/dice3.60caaa74.svg";